export function fetchSection(url, section_id, el, callback) {
  if (!url || !section_id) {
    console.error('Please provide a valid url and section id.');
    return;
  }

  const urlHasParams = url.includes('?');
  url = urlHasParams ? `${url}&` : `${url}?`;

  fetch(`${ url }section_id=${ section_id }`)
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Something went wrong');
      }
    })
    .then(data => {
      if (!el) {
        console.error('No element provided.');
        return;
      }

      el.innerHTML = data;

      if (typeof callback === "function") callback();
    })
    .catch((error) => {
      console.log(error)
    });
}
